import { Component, ChangeDetectorRef, ChangeDetectionStrategy, KeyValueDiffers, ViewEncapsulation } from '@angular/core';
import { MarkdownHoodClass } from './ngx-markdown.class';
import { MarkdownService } from './ngx-markdown.service';
function instanceOf(object) {
    return object !== undefined;
}
export class MarkdownComponent extends MarkdownHoodClass {
    constructor(markdownService, changeDetectorRef, keyValueDiffers) {
        super(markdownService, changeDetectorRef, keyValueDiffers);
        this.markdownService = markdownService;
        this.changeDetectorRef = changeDetectorRef;
        this.keyValueDiffers = keyValueDiffers;
    }
    ngAfterViewInit() {
        if (!this.string) {
            this.storeNgContent();
            this.change = true;
        }
    }
    ngDoCheck() {
        let changes = null;
        changes = this.differ.options.diff(this.options);
        if (changes) {
            changes.forEachChangedItem((record) => {
                if (this.options) {
                    this.options[record.key] = record.currentValue;
                    this.stringMarked = undefined;
                    this.change = true;
                }
            });
        }
    }
    ngOnChanges(changes) {
        this.onChanges(['callback', 'string'], changes);
    }
}
MarkdownComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'ngx-markdown',
                template: `<ng-container *ngIf="!string"><div #el><ng-content></ng-content></div></ng-container><ng-container *ngIf="string"><div *ngIf="stringMarked else loading" #el [innerHTML]="stringMarked"></div></ng-container><ng-template #loading><div [innerHTML]="markdownService.config[0].loadingTemplate"></div></ng-template>`
            },] },
];
MarkdownComponent.ctorParameters = () => [
    { type: MarkdownService, },
    { type: ChangeDetectorRef, },
    { type: KeyValueDiffers, },
];
//# sourceMappingURL=ngx-markdown.component.js.map